export default function ConfirmationPopover({dialog,onEvent}){

  if( !dialog ){
    return null;;
  }

  debugger;

  return (
    <div 
          onClick={e => {
            onEvent && onEvent({type:"cancel"});
          }}
          class="fixed-overlay">
            <div onClick={e => {
              e.stopPropagation();
            }} class="overlay-dark" style={{ 

              left:dialog.x,
              top:dialog.y,
              padding:5,
              transform:'translate(-50%,0)',
              
            }}>
            <div>Are you sure you want to do that?</div>
            <div>{dialog.type}</div>
            <div><button onClick={() => {
              onEvent && onEvent({type:"confirm"})
            }}>Confirm</button><button onClick={() => {
              onEvent && onEvent({type:"cancel"});
            }}>Cancel</button>
            </div>
          </div>
        </div>
  )


}
